<template>
  <div class="questions-component p-4 rounded-lg shadow-md bg-white">
    <LoadingOverlay :visible="saving" text="Guardando..." spinnerClass="text-blue-500" textClass="text-green-300" />    
    <div v-for="(question, index) in evaluation.goals" :key="index" class="mb-6">
      <p class="text-sm font-medium text-gray-600 mb-2 font-bold">
        {{ index + 1 }}. {{ question.objective }}
      </p>
      <div class="flex items-center space-x-4">
        <select
          :name="'question-' + index"
          v-model="answers[index]"
          class="border border-gray-300 rounded-lg px-4 py-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
        >
          <option value="" disabled>Seleccione un porcentaje de cumplimiento</option>
          <option v-for="value in percentages" :key="value" :value="value">
            {{ value }}%
          </option>
        </select>
      </div>
    </div>
    <div class="flex justify-end mt-5">
      <button
        type="button"
        @click="handleSubmit"
        :disabled="!allQuestionsAnswered"
        class="px-6 py-2 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:bg-gray-400 disabled:cursor-not-allowed btn-success"
      >
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import request from "@/services/request"; // Asegúrate de que este servicio esté configurado
import { mapActions } from 'vuex';
import LoadingOverlay from '../GlobalLoad.vue';


export default {
  components: {
    LoadingOverlay,
  },
  name: "evaluation-fill-scope",
  props: {
    evaluation: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      percentages: ["5","10","15","20","25","30","35","40","45","50","55","60","65","70","75","80","85","90","95","100"],
      answers: [], // Contendrá las respuestas seleccionadas para cada pregunta
      saving: false, // Estado de guardado
    };
  },
  computed: {
    allQuestionsAnswered() {
      // Verifica que todas las preguntas tengan un valor seleccionado
      return this.evaluation.goals.every((_, index) => !!this.answers[index]);
    },
  },
  methods: {
    async handleSubmit() {
      if (!this.allQuestionsAnswered) {
        this.errorNotification("Asigne un porcentaje de cumplimiento a cada meta.");
        return;
      }
      this.saving = true;

      const responsesPayload = this.evaluation.goals.map((question, index) => ({
        goal_id: question.id, // Ajusta según el ID de la meta
        evaluation_id: this.evaluation.id,
        intermediate_fulfillment: this.answers[index],
      }));

      try {
        const { data } = await request.post("/evaluations/scope-complete", {
          evaluation_id: this.evaluation.id,
          user_id: this.evaluation.user_id, // Ajusta si usas Vuex o una prop para el usuario
          responses: responsesPayload,
        });

        if (data) {
            this.saving = false;

            this.successNotification("Evaluación guardada exitosamente.");
            this.$router.push({ path: '/evaluations/manager-evaluations', name: 'manager-evaluations' });
        }
      } catch (error) {
          console.error("Error al enviar la evaluación:", error);
        this.errorNotification("Hubo un error al enviar la evaluación. Por favor, inténtelo de nuevo.");
        this.saving = false;
          
      }
    },    
    ...mapActions({
			successNotification: 'alert/success',
			errorNotification: 'alert/error',
		}),
  },
};
</script>

<style scoped>
.questions-component {
  width: 100%;
  margin: auto;
  border: 1px solid #e5e7eb;
}
.font-bold {
  font-weight: bold;
}
</style>
